module.exports = __webpack_public_path__ + "static/media/illustration-interior-design.5297af39.png";